module.exports = __webpack_public_path__ + "static/img/6.e829746.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/6.png
// module id = 9di8
// module chunks = 0